import React from 'react';
import { Query } from 'react-apollo';
import CircularProgress from '@material-ui/core/CircularProgress';

import { GET_CHATS } from '../../queries';
import ChatList from './chat-list';

const Mailbox = () => (
  <Query query={GET_CHATS}>
    {({ loading, error, data }) => {
      if (loading) {
        return (
          <div style={{ textAlign: 'center' }}>
            <CircularProgress />
          </div>
        );
      }
      if (error) return <div>Не вдалося завантажити діалоги</div>;

      const userChats =
        data.userChats &&
        data.userChats.sort(
          (a, b) => b.lastMessage.createdAt - a.lastMessage.createdAt
        );

      return <ChatList userChats={userChats} />;
    }}
  </Query>
);

export default Mailbox;
